<template>
  <el-dialog
    class="radish-dia"
    title="推荐给他人"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :closeOnClickModal="false"
    :closeOnPressEscape="false"
  >
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="备注"> <el-input type="textarea" v-model="form['备注']" :span="3"></el-input> </el-form-item>
      <el-form-item class="is-required" label="提醒">
        <el-select
          v-model="form['提醒']"
          multiple
          filterable
          size="small"
          placeholder="选择提醒对象"
          style="display: block"
        >
          <el-option v-for="(item, k) in users" :key="k" :label="item" :value="item"> </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false" style="margin-right:5px">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    onConfirm: Function,
  },
  data: function() {
    return {
      dialogVisible: false,
      form: {},
      users: [],
      radish: {},
    }
  },
  methods: {
    show: function(radish) {
      this.radish = Object.assign({}, radish)
      this.form = {}
      this.dialogVisible = true
    },
    async handleConfirm() {
      if (this.followLoading) return
      this.followLoading = true
      if (!this.form['提醒']) {
        return this.$message.warning('请选择提醒对象')
      }
      try {
        const res = await app.service('notify').addNotify({
          notify: {
            title: `${app.user.account}向您推荐了${this.radish['姓名']}`,
            type: '人选',
            action: '特定推荐',
            content: this.form['备注'] || '',
            rid: this.radish._id,
          },
          to: this.form['提醒'],
        })
        if (res.status === 'success') {
          this.dialogVisible = false
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        this.$message.error(error.message)
      }
      this.followLoading = false
    },
  },
  async created() {
    if (!app.accounts) {
      await app.getUsers()
    }
    this.users = app.accounts
  },
}
</script>
